import { loadable } from '@fiverr-private/perseus';
import { BUYABLE_TYPE } from '@fiverr-private/price_upfront_components';

const PriceWithFees = loadable(() => import(/* webpackChunkName: "PriceWithFees" */ './PriceWithFees'));

export const PRICE_UPFRONT_CONFIG = {
    components: [
        {
            component: PriceWithFees,
            options: {
                name: 'Price With Fees',
                inputs: [
                    {
                        name: 'amount',
                        type: 'number',
                        required: true,
                        helperText: 'Amount in USD',
                    },
                    {
                        name: 'currency',
                        type: 'enum',
                        required: true,
                        enum: ['USD', 'USER'],
                        helperText: 'Display in dollars or user currency',
                    },
                    {
                        name: 'buyableType',
                        type: 'enum',
                        required: true,
                        enum: Object.values(BUYABLE_TYPE),
                        helperText: 'Type of buyable for fee calculation',
                    },
                ],
                defaults: {
                    bindings: {
                        'component.options.currencyObject': 'state.contextData.currencyObject',
                    },
                },
            },
        },
    ],
};
